"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var SearchBarContext_1 = require("../../../SearchBarContext");
var SuggestionLink_1 = __importDefault(require("../SuggestionLink"));
function BodyStyleTile(_a) {
    var bodyStyle = _a.bodyStyle, handleDefaultSuggestionClicked = _a.handleDefaultSuggestionClicked, _b = _a.isViewAllTile, isViewAllTile = _b === void 0 ? false : _b, width = _a.width;
    var cdnBaseUrl = (0, SearchBarContext_1.useSearchBarContext)().cdnBaseUrl;
    return (react_1.default.createElement(SuggestionLink_1.default, { className: (0, classnames_1.default)('flex w-full flex-col items-center gap-4 rounded-[6px] border border-grey-1 bg-grey-1 p-8 transition-colors hover:border-blue-6', {
            'hidden m:flex': isViewAllTile
        }), "data-analytics-id": "Default Suggestions", "data-analytics-attributes": JSON.stringify({
            category: 'Vehicle Styles',
            label: bodyStyle.text
        }), "data-qa": "Default Search Bodystyles", defaultSuggestion: bodyStyle, handleDefaultSuggestionClicked: handleDefaultSuggestionClicked, style: { minWidth: width } },
        react_1.default.createElement("img", { alt: bodyStyle.text, className: (0, classnames_1.default)('max-w-full', {
                'mt-auto flex w-fit rounded-full bg-white p-[10px]': isViewAllTile
            }), src: "".concat(cdnBaseUrl).concat(bodyStyle.image) }),
        react_1.default.createElement("div", { className: "w-full overflow-hidden text-ellipsis  whitespace-nowrap text-center text-blue-6 tl-body-s" }, bodyStyle.text)));
}
exports.default = BodyStyleTile;
//# sourceMappingURL=BodyStyleTile.js.map